import { ErrorCode } from '@shared/utils/enums';

/**
 * Error codes for which the token interceptor logs the user out, mapped to the route
 * to redirect to. The login component checks membership to avoid issuing a competing
 * navigation that would cancel this redirect.
 */
export const LOGOUT_ERROR_REDIRECTS: Partial<Record<ErrorCode, string>> = {
  [ErrorCode.TokenExpired]: '/login',
  [ErrorCode.RefreshExpired]: '/login',
  [ErrorCode.InvalidCredentials]: '/login',
  [ErrorCode.UserDeactivated]: 'deactivated',
  [ErrorCode.UserLogin]: 'deactivated',
  [ErrorCode.UserDeactivatedAuth]: 'deactivated',
};
